
import {CricrushConfig} from "./../cc-imports";
import FirebaseSignInUtils from './firebase/FirebaseSignInUtils'
import FirebaseNotificationUtils from './firebase/FirebaseNotificationUtils'
import FirebaseInvitesUtils from './firebase/FirebaseInvitesUtils'
import Firebase from 'firebase/app'

var inviteUsed = false;
var invitedBy = undefined;

const FirebaseUtils = {

    getIdTokenWhenAuthChanged:(callback)=>{
        Firebase.auth().onAuthStateChanged(function(user) {
            Firebase.auth().currentUser && Firebase.auth().currentUser.getIdToken(false).then((idToken)=>{
                callback && callback(idToken);
            })
        });
    },

    initializeFireBase: (actions, callback) => {

        if (!Firebase.apps.length) {
            //console.log(CricrushConfig.firebaseConfig)
            Firebase.initializeApp(CricrushConfig.firebaseConfig);
        }

        FirebaseInvitesUtils.getInitialLinkParams((params) => {
            invitedBy = params
        });

        FirebaseInvitesUtils.subscribeToOnLinkEvents((params) => {
            invitedBy = params;
        });

       /* const unsubscribe = Firebase.links().onLink((url) => {
            //FirebaseUtils.redirectBasedOnInviteLinks(ccTabNavigation, actions);
        });*/

        //On new account creation, the authStatus change not fired. so we need to fire it here once again. this is a rnfirebase specific method
        /*Firebase.auth().onUserChanged((user)=>{
            if(user && !user.isAnonymous){
                user.getIdToken(false).then((res)=>{
                    if(user.email==null || user.email==undefined){
                        user.email = FirebaseSignInUtils._composeFBEmail(user);
                    }
                    actions.getOrCreateUserByEmail({ email:user.email, accessToken : res.idToken }).then(()=>{
                        callback();
                    })
                })
            }
        });*/

        Firebase.auth().onAuthStateChanged(function(user) {

            const url_string = window.location.href; //window.location.href
            const url = new URL(url_string);
            const invitedById = url.searchParams.get("invitedBy");

            const linkParams = invitedById;
           // console.log(user)

            if (user) {
                if (user.isAnonymous) {
                    //actions.openHome();
                    //actions.anonymousUserIn();
                }
                else {
                    user.getIdToken(false).then((res) => {
                        if (user.email == null || user.email == undefined) {
                            user.email = FirebaseSignInUtils._composeFBEmail(user);
                        }
                        actions.getOrCreateUserByEmail({email: user.email, invitedBy: {id: invitedBy } },res.idToken).then(() => {
                            actions.openHome();
                            callback && callback();
                        })
                    })
                }

                if (!inviteUsed) {
                    //FirebaseUtils.redirectBasedOnInviteLinks(ccTabNavigation, actions);
                    inviteUsed = true;
                }
            } else {
                Firebase.auth().signInAnonymouslyAndRetrieveData().then(() => {
                    actions.signOutUser();
                }).catch(function (error) {
                    console.log(error)
                });
                actions.fbUserNotFound();
            }
        });
    },
    ...FirebaseSignInUtils,
    ...FirebaseNotificationUtils,
    ...FirebaseInvitesUtils
};

export {FirebaseUtils};


// WEBPACK FOOTER //
// ./src/app/lib/FirebaseUtils.js